import Backbone from 'backbone';

export default Backbone.Model.extend({
	defaults: function() {
		return {
			Delete: 'Delete',
			NoResults: 'No results founds'
		};
	},

	url: function() {
		return document.URL;
	}
});
